import { gql } from '@apollo/client'

const SESSION_FRAGMENT = gql`
  fragment SessionFields on Session {
    id
		title
		starts_at
		ends_at
		slot_duration
		slot_gap
		guardian_restriction
  }
`

export default SESSION_FRAGMENT
